import StatusChip from 'components/@extended/StatusChip';
import { ClassifierData } from 'types/classifiers';
import { getClassifierText, t } from 'utils/getTranslations';

type Props = {
    classifierData: ClassifierData;
    timecardLanguageTypeCode?: string;
    /**
     * The chip's tone. A form that checks its text against the language passes `neutral`, or `warning` while the
     * text does not read as it; a caller with no check behind the chip keeps the warning tone.
     */
    type?: 'neutral' | 'warning';
};

const TimecardLanguageLabel = ({
    classifierData,
    timecardLanguageTypeCode = '',
    type = 'warning',
}: Props): JSX.Element => {
    const labelText = getClassifierText(classifierData, timecardLanguageTypeCode);

    return <StatusChip label={t('in-language', { language: labelText })} type={type} />;
};

export default TimecardLanguageLabel;
